import React from 'react';
import { createFeature } from '@edreamsodigeo/frontend-core';
import { ALTERNATIVE_FLIGHTS_BROKEN_FLOW } from 'clientState/ab/aliases';
import AlternativeFlightLayer from './AlternativeFlightLayer';
import BrokenFlowModal from '@components/Results/Components/Modals/BrokenFlowModal';
import { FeeSelected } from 'generated/graphql';
import { useFlowTools } from 'flowTools/useFlowTools';
import { PageType } from 'clientState/providers/AlternativeItineraryProvider/hooks';

export const BrokenFlowModalComponent = () => {
  return <BrokenFlowModal open={true} onClose={() => {}} />;
};

const AlternativeFlightBrokenFlow = () => {
  const { isMobile } = useFlowTools();
  return (
    <AlternativeFlightLayer
      hasToCheckPrimeMember={false}
      hasToCheckPrimeOffer={false}
      nonIssuable={true}
      feeSelected={FeeSelected.PrimePrice}
      withDiscount={false}
      isBrokenFlow={true}
      overrideAction={true}
      showLoadingBar={isMobile ? false : true}
      goToSummary={isMobile ? true : false}
      pageName={isMobile ? PageType.Summary : PageType.Pax}
      simpleUI={false}
    />
  );
};

const AlternativeFlightBrokenFlowSimpleDesign = () => {
  const { isMobile } = useFlowTools();
  return (
    <AlternativeFlightLayer
      hasToCheckPrimeMember={false}
      hasToCheckPrimeOffer={false}
      nonIssuable={true}
      feeSelected={FeeSelected.PrimePrice}
      withDiscount={false}
      isBrokenFlow={true}
      overrideAction={true}
      showLoadingBar={isMobile ? false : true}
      goToSummary={isMobile ? true : false}
      pageName={isMobile ? PageType.Summary : PageType.Pax}
      simpleUI={true}
    />
  );
};

const AlternativeFlightBrokenFlowVersioned = createFeature({
  name: ALTERNATIVE_FLIGHTS_BROKEN_FLOW,
  variations: [
    BrokenFlowModalComponent,
    AlternativeFlightBrokenFlow,
    AlternativeFlightBrokenFlowSimpleDesign,
    AlternativeFlightBrokenFlow,
  ],
  version: 1,
});

export default AlternativeFlightBrokenFlowVersioned;
